import React from "react";
import HeaderSection from "../HeaderSection";
import styles from "./style.module.scss";
import Devider from "../Devider";
const expData = [
  {
    id: 1,
    title: "Full Stack Developer",
    jobTitle: "ReactJS | NextJS | React Native | NodeJS | ASP.NET",
    compnay: "SiTech Company",
    from: "2022",
    to: "Currently",
    description:
      "Used ReactJS and NextJS to develop responsive web applications and built scalable RESTful APIs with Node.js Express and ASP.NET, integrating both NoSQL and SQL databases.",
  },
  {
    id: 2,
    title: "Full Stack Developer",
    jobTitle: "ReactJS | NodeJS | Magento 2 | WordPress",
    compnay: "Shopyard Company",
    from: "2020",
    to: "2022",
    description:
      "Leveraged ReactJS to develop responsive web applications and built RESTful APIs with Node.js. Additionally, developed fully responsive Magento and WordPress websites tailored to customer requirements",
  },
  {
    id: 3,
    title: "Full Stack Developer",
    jobTitle: "Cofounder",
    compnay: "Sewara",
    from: "2022",
    to: "Current",
    description:
      "Developed a digital tool for identifying children's information in schools and public places, utilizing React for the front-end, ASP API for the back-end, and React Native for the mobile app.",
  },
];
const Experience = () => {
  return (
    <>
      <HeaderSection title={"Take a look at my work experience"} />
      <div className={styles.experience}>
        {expData.map((el) => (
          <div className={styles.experience_item} key={el.id}>
            <div className={styles.experience_item_title}>
              <div className={styles.experience_item_title_img}>
                <img src="/assets/images/dot-exp.svg" alt="dot-exp" />
              </div>
              <div className={styles.experience_item_title_job}>
                <div className={styles.title}>
                  <h1>{el.title}</h1>
                  <p>{el.jobTitle}</p>
                  <h5>{el.description}</h5>
                </div>
                <div className={styles.experience_item_company}>
                  <p>
                    {el.from} - {el.to}
                  </p>
                  <p>{el.compnay}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Devider />
    </>
  );
};

export default Experience;
